export enum PartSpecificationTypes {
    OffTheShelf = 'OffTheShelf',
    Custom = 'Custom',
}
